export default __webpack_public_path__ + "static/media/ico-rds-score-low.cf477934.svg";